import { render } from "./ClientGroup.vue?vue&type=template&id=5a4bb80d"
import script from "./ClientGroup.vue?vue&type=script&lang=js"
export * from "./ClientGroup.vue?vue&type=script&lang=js"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__